module.exports = __webpack_public_path__ + "static/media/szymon-grzelaczyk.65d79c47.jpg";